module.exports = __webpack_public_path__ + "img/sort-icon-up-down.fea40db1.svg";